import styled from "@emotion/styled";
import { FormControl, Typography } from "@mui/material";

export const FormControlLayout = styled(FormControl)`
  //padding: 20px 12px 10px 12px;
  margin: 12px;
  min-width: 180px;
  width: 100%;
`;

export const StatusText = styled(Typography)`
  width: 100%;
`;

const ITEM_HEIGHT = 120;
const ITEM_PADDING_TOP = 12;
export const MenuProps = {
  slotProps: {
    paper: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
        border: "0px",
      },
    },
  },
};
